module.exports = __webpack_public_path__ + "static/media/Sidebar-expenses-icon-inactive.f278c7f0.svg";